// @generated drizzle-zero signature:sha256:893598dfcf70eca4d7ed3f9546bedb7d9567b4751e2472e8afc90415bb4f18a0
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.
import { createBuilder } from "@rocicorp/zero";
const hl7EventLogTable = {
    name: "HL7EventLog",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        message: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "resource",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        direction: {
            type: "string",
            optional: true,
            customType: null,
        },
        errorMessage: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "error_message",
        },
        resourceRef: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "resource_ref",
        },
        messageControlId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "message_control_id",
        },
        ack: {
            type: "string",
            optional: true,
            customType: null,
        },
        ackCode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ack_code",
        },
        ackReceivedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "ack_received_at",
        },
    },
    primaryKey: ["id"],
    serverName: "hl7_event_log",
};
const accountTable = {
    name: "account",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        providerId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "provider_id",
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        passwordSetAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "password_set_at",
        },
    },
    primaryKey: ["id"],
};
const activeSubstanceDetailsTable = {
    name: "activeSubstanceDetails",
    columns: {
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        doseCalcMode: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "dose_calc_mode",
        },
        doseUnitId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "dose_unit_id",
        },
        dosePrecision: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_precision",
        },
        doseLimits: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "dose_limits",
        },
        roundingMode: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "rounding_mode",
        },
        minIntervalValue: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "min_interval_value",
        },
        minIntervalDurationUnit: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "min_interval_unit",
        },
        overdosePreventionLevel: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "overdose_prevention_level",
        },
        hasSaltContent: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "has_salt_content",
        },
        saltContentNotes: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "salt_content_notes",
        },
        molarMassFreeBase: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "molar_mass_free_base",
        },
        molarMassSaltBase: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "molar_mass_salt_base",
        },
        saltFactor: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "salt_factor",
        },
        additionalApprovalRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "requires_additional_approval",
        },
        cytotoxic: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        routeWarning: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "route_warning",
        },
        productionNotes: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "production_notes",
        },
        externalInformationLink: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "external_information_link",
        },
        preparationType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "preparation_type",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["drugCatalogItemId"],
    serverName: "active_substance_details",
};
const activeSubstanceHazardClassesTable = {
    name: "activeSubstanceHazardClasses",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        activeSubstanceDetailId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "active_substance_detail_id",
        },
        hazardClassId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "hazard_class_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "active_substance_hazard_classes",
};
const addressesTable = {
    name: "addresses",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        country: {
            type: "string",
            optional: true,
            customType: null,
        },
        region: {
            type: "string",
            optional: true,
            customType: null,
        },
        city: {
            type: "string",
            optional: true,
            customType: null,
        },
        postalCode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "postal_code",
        },
        addressLine: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_line",
        },
        additionalInfo: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "additional_info",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "address",
};
const adminRoutesTable = {
    name: "adminRoutes",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "administration_routes",
};
const applicationFormsTable = {
    name: "applicationForms",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        preparationRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "preparation_required",
        },
        carrierRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "carrier_required",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "application_forms",
};
const batchesTable = {
    name: "batches",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        tradeNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "trade_name_id",
        },
        consumableId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "consumable_id",
        },
        supplierCompanyId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "supplier_company_id",
        },
        lotNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "lot_number",
        },
        expiryDate: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "expiry_date",
        },
        receivedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "received_at",
        },
        receivedQuantity: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "received_quantity",
        },
        quantity: {
            type: "number",
            optional: true,
            customType: null,
        },
        stockLocationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_location_id",
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        rawZiv: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "raw_ziv",
        },
        ammsProductId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "amms_product_id",
        },
        ammsProductDescription: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "amms_product_description",
        },
        acknowledgedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "acknowledged_at",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const cancerTypesTable = {
    name: "cancerTypes",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "cancer_types",
};
const cleanroomStatesTable = {
    name: "cleanroomStates",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        state: {
            type: "json",
            optional: false,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "cleanroom_states",
};
const companiesTable = {
    name: "companies",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const compoundMappingsTable = {
    name: "compoundMappings",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        mappingType: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "mapping_type",
        },
        sourceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "source_id",
        },
        machineId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "machine_id",
        },
        carrierType: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "carrier_type",
        },
        label: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "compound_mappings",
};
const compoundOrdersTable = {
    name: "compoundOrders",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        externalId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "external_id",
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        orderId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "order_id",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        machineOrderXml: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "machine_order_xml",
        },
        generatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "generated_at",
        },
        sentAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "sent_at",
        },
        error: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "compound_orders",
};
const compoundResultComponentsTable = {
    name: "compoundResultComponents",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        compoundResultId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "compound_result_id",
        },
        componentTypeId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "component_type_id",
        },
        internalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "internal_id",
        },
        lotNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "lot_number",
        },
        expirationDate: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "expiration_date",
        },
        stockLocation: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_location",
        },
        specifiedVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "specified_volume",
        },
        measuredVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "measured_volume",
        },
        productFunction: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "product_function",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "compound_result_components",
};
const compoundResultsTable = {
    name: "compoundResults",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        compoundOrderId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "compound_order_id",
        },
        preparationDate: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "preparation_date",
        },
        releaseStatus: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "release_status",
        },
        releaseComment: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "release_comment",
        },
        measuredCarrierVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "measured_carrier_volume",
        },
        measuredDrugDose: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "measured_drug_dose",
        },
        carrierDeviation: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "carrier_deviation",
        },
        drugDeviation: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "drug_deviation",
        },
        rawXml: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "raw_xml",
        },
        receivedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "received_at",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "compound_results",
};
const consumablesTable = {
    name: "consumables",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        barcode: {
            type: "string",
            optional: true,
            customType: null,
        },
        nationalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_id",
        },
        category: {
            type: "string",
            optional: true,
            customType: null,
        },
        unitsPerPackage: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "units_per_package",
        },
        minimumStock: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "minimum_stock",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const containerMaterialsTable = {
    name: "containerMaterials",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "container_materials",
};
const containerTypesTable = {
    name: "containerTypes",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "container_types",
};
const customersTable = {
    name: "customers",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        pharmacyId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "pharmacy_id",
        },
        email: {
            type: "string",
            optional: true,
            customType: null,
        },
        phone: {
            type: "string",
            optional: true,
            customType: null,
        },
        isSameAddress: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_same_address",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        ikNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "ik_number",
        },
        producerNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "producer_number",
        },
        labelName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "label_name",
        },
        addressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_id",
        },
        deliveryAddressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "delivery_address_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "customer",
};
const diagnosesTable = {
    name: "diagnoses",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const discardsTable = {
    name: "discards",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        batchId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "batch_id",
        },
        restVialId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "rest_vial_id",
        },
        returnId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "return_id",
        },
        lastLocationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "last_location_id",
        },
        reason: {
            type: "string",
            optional: true,
            customType: null,
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
};
const drugCatalogItemsTable = {
    name: "drugCatalogItems",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        catalogType: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "catalog_type",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        prescribingName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "prescribing_name",
        },
        code: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "manual_id",
        },
        atcCode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "atc_code",
        },
        nationalDrugId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_drug_id",
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        hasCategories: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "has_categories",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "drug_catalog_items",
};
const drugCatalogItemsCategoriesTable = {
    name: "drugCatalogItemsCategories",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        drugCategoryId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_category_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "drug_catalog_items_categories",
};
const drugsCategoriesTable = {
    name: "drugsCategories",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        parentId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "parent_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "drugs_categories",
};
const eventLogsTable = {
    name: "eventLogs",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        domain: {
            type: "string",
            optional: true,
            customType: null,
        },
        resource: {
            type: "string",
            optional: true,
            customType: null,
        },
        resourceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "resource_id",
        },
        event: {
            type: "string",
            optional: true,
            customType: null,
        },
        action: {
            type: "string",
            optional: true,
            customType: null,
        },
        patches: {
            type: "json",
            optional: true,
            customType: null,
        },
        ipAddress: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ip_address",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        details: {
            type: "json",
            optional: true,
            customType: null,
        },
        search: {
            type: "string",
            optional: true,
            customType: null,
        },
        impersonatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "impersonated_by",
        },
        performedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "performed_by",
        },
        performedAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "performed_at",
        },
    },
    primaryKey: ["id"],
    serverName: "event_log",
};
const generalPhysiciansTable = {
    name: "generalPhysicians",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        specialty: {
            type: "string",
            optional: true,
            customType: null,
        },
        phone: {
            type: "string",
            optional: true,
            customType: null,
        },
        email: {
            type: "string",
            optional: true,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "general_physicians",
};
const groupsTable = {
    name: "groups",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        type: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "group",
};
const hazardClassesTable = {
    name: "hazardClasses",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "hazard_classes",
};
const insuranceCompaniesTable = {
    name: "insuranceCompanies",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        nationalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_id",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "insurance_companies",
};
const locationsTable = {
    name: "locations",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: false,
            customType: null,
        },
        logo: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "created_at",
        },
        metadata: {
            type: "string",
            optional: true,
            customType: null,
        },
        address: {
            type: "json",
            optional: true,
            customType: null,
        },
    },
    primaryKey: ["id"],
    serverName: "location",
};
const medicationProfileAllowedCarrierSolutionsTable = {
    name: "medicationProfileAllowedCarrierSolutions",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        medicationProfileId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "medication_profile_id",
        },
        solutionDrugId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "solution_drug_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "medication_profile_allowed_carrier_solutions",
};
const medicationProfileAllowedReconstitutionDiluentsTable = {
    name: "medicationProfileAllowedReconstitutionDiluents",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        medicationProfileId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "medication_profile_id",
        },
        solutionDrugId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "solution_drug_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "medication_profile_allowed_reconstitution_diluents",
};
const medicationProfilesTable = {
    name: "medicationProfiles",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        medicineFormId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "medicine_form_id",
        },
        name: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "display_name",
        },
        reconstitutionRequired: {
            type: "boolean",
            optional: false,
            customType: null,
            serverName: "reconstitution_required",
        },
        isDrySubstance: {
            type: "boolean",
            optional: false,
            customType: null,
            serverName: "is_dry_substance",
        },
        oralQuantityBasis: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "oral_quantity_basis",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "medication_profiles",
};
const medicationStabilityRulesTable = {
    name: "medicationStabilityRules",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        medicationProfileId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "medication_profile_id",
        },
        stabilityRuleId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "stability_rule_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "medication_stability_rules",
};
const medicineFormsTable = {
    name: "medicineForms",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        reconstitutionRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "reconstitution_required",
        },
        isDrySubstance: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_dry_substance",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "medicine_forms",
};
const orderBatchesTable = {
    name: "orderBatches",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        orderId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "order_id",
        },
        batchId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "batch_id",
        },
        therapySequenceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        category: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "order_batch",
};
const ordersTable = {
    name: "orders",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        internalId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "internal_id",
        },
        productionLocationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "production_location_id",
        },
        distributedOrders: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "distributed_orders",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "order",
};
const patientCharacteristicsTable = {
    name: "patientCharacteristics",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        height: {
            type: "number",
            optional: true,
            customType: null,
        },
        weight: {
            type: "number",
            optional: true,
            customType: null,
        },
        gfr: {
            type: "number",
            optional: true,
            customType: null,
        },
        bsa: {
            type: "number",
            optional: true,
            customType: null,
        },
        bsaFormula: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "bsa_formula",
        },
        aibw: {
            type: "number",
            optional: true,
            customType: null,
        },
        aibwFormula: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "aibw_formula",
        },
        diabetes: {
            type: "string",
            optional: true,
            customType: null,
        },
        smoker: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        alcoholic: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        useAibw: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "use_aibw",
        },
        diagnosisId: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_characteristic",
};
const patientContactsTable = {
    name: "patientContacts",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        contactType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "contact_type",
        },
        name: {
            type: "string",
            optional: true,
            customType: null,
        },
        relationship: {
            type: "string",
            optional: true,
            customType: null,
        },
        phone: {
            type: "string",
            optional: true,
            customType: null,
        },
        businessPhone: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "business_phone",
        },
        email: {
            type: "string",
            optional: true,
            customType: null,
        },
        addressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_contact",
};
const patientEncountersTable = {
    name: "patientEncounters",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        sectionId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "section_id",
        },
        wardId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ward_id",
        },
        physicianId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "physician_id",
        },
        customerId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "customer_id",
        },
        ambulatory: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        startedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "started_at",
        },
        endedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "ended_at",
        },
        reason: {
            type: "string",
            optional: true,
            customType: null,
        },
        visitNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "visit_number",
        },
        patientClass: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "patient_class",
        },
        admissionType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "admission_type",
        },
        pointOfCare: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "point_of_care",
        },
        room: {
            type: "string",
            optional: true,
            customType: null,
        },
        bed: {
            type: "string",
            optional: true,
            customType: null,
        },
        locationDescription: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "location_description",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        rawPv1: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "raw_pv1",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_encounter",
};
const patientGfrsTable = {
    name: "patientGfrs",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        labTime: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "lab_time",
        },
        gfr: {
            type: "number",
            optional: false,
            customType: null,
        },
        method: {
            type: "string",
            optional: false,
            customType: null,
        },
        serumCreatinine: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "serum_creatinine",
        },
        serumUnit: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "serum_unit",
        },
        urineCreatinine: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "urine_creatinine",
        },
        urineVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "urine_volume",
        },
        collectionTime: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "collection_time",
        },
        ageMonths: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "age_months",
        },
        weight: {
            type: "number",
            optional: true,
            customType: null,
        },
        height: {
            type: "number",
            optional: true,
            customType: null,
        },
        bsa: {
            type: "number",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_gfr",
};
const patientIdentifiersTable = {
    name: "patientIdentifiers",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        system: {
            type: "string",
            optional: false,
            customType: null,
        },
        systemName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "system_name",
        },
        value: {
            type: "string",
            optional: false,
            customType: null,
        },
        use: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_identifier",
};
const patientInsurancesTable = {
    name: "patientInsurances",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        country: {
            type: "string",
            optional: true,
            customType: null,
        },
        companyId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "company_id",
        },
        insuranceNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "insurance_number",
        },
        policyNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "policy_number",
        },
        expirationDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expiration_date",
        },
        privatePatient: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "private_patient",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_insurance",
};
const patientProtocolsTable = {
    name: "patientProtocols",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        protocolId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "protocol_id",
        },
        startDate: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "start_date",
        },
        endDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "end_date",
        },
        cycles: {
            type: "number",
            optional: true,
            customType: null,
        },
        cycleStartDates: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "cycle_start_dates",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_protocols",
};
const patientTherapySequenceTable = {
    name: "patientTherapySequence",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        internalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "internal_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        protocolId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "protocol_id",
        },
        patientProtocolId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "patient_protocol_id",
        },
        sequenceGroupId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "sequence_group_id",
        },
        therapyDate: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "therapy_date",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        pharmacistValidatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "pharmacist_validated_by",
        },
        pharmacistValidatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "pharmacist_validated_at",
        },
        patientArrivedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "patient_arrived_at",
        },
        doctorValidatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "doctor_validated_by",
        },
        doctorValidatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "doctor_validated_at",
        },
        responsibleDoctorId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "responsible_doctor_id",
        },
        administeredBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "administered_by",
        },
        administeredAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "administered_at",
        },
        administrationMode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "administration_mode",
        },
        patientScanSkipped: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "patient_scan_skipped",
        },
        administeredOnDispatch: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "administered_on_dispatch",
        },
        producedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "produced_at",
        },
        releasedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "released_at",
        },
        producedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "produced_by",
        },
        productionSource: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "production_source",
        },
        restVialCreated: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "rest_vial_created",
        },
        qaResult: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "qa_result",
        },
        prescriptionSource: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "prescription_source",
        },
        returnedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "returned_by",
        },
        returnedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "returned_at",
        },
        cancelledBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "cancelled_by",
        },
        cancelledAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cancelled_at",
        },
        cancellationReason: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "cancellation_reason",
        },
        discardedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "discarded_by",
        },
        discardedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "discarded_at",
        },
        discardReason: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "discard_reason",
        },
        discardNote: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "discard_note",
        },
        remadeBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "remade_by",
        },
        remadeAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "remade_at",
        },
        remadeToId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "remade_to_id",
        },
        isNote: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_note",
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        therapyNote: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "therapy_note",
        },
        pharmacyNote: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "pharmacy_note",
        },
        cycle: {
            type: "number",
            optional: true,
            customType: null,
        },
        day: {
            type: "number",
            optional: true,
            customType: null,
        },
        time: {
            type: "string",
            optional: false,
            customType: null,
        },
        carrierSolutionId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "carrier_solution_id",
        },
        applicationFormId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "application_form_id",
        },
        orderId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "order_id",
        },
        duration: {
            type: "number",
            optional: true,
            customType: null,
        },
        volume: {
            type: "number",
            optional: true,
            customType: null,
        },
        volumeMode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "volume_mode",
        },
        chairId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "chair_id",
        },
        preparationType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "preparation_type",
        },
        doseBasisHeight: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_height",
        },
        doseBasisWeight: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_weight",
        },
        doseBasisBsa: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_bsa",
        },
        doseBasisGfr: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_gfr",
        },
        doseBasisAibw: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_aibw",
        },
        doseBasisUseAibw: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "dose_basis_use_aibw",
        },
        doseBasisBsaFormula: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "dose_basis_bsa_formula",
        },
        doseBasisGfrMethod: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "dose_basis_gfr_method",
        },
        doseBasisGfrLabTime: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_gfr_lab_time",
        },
        doseBasisSerumCreatinine: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_serum_creatinine",
        },
        doseBasisSerumUnit: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "dose_basis_serum_unit",
        },
        doseBasisAgeMonths: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_basis_age_months",
        },
        doseCopiedFromSequenceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "dose_copied_from_sequence_id",
        },
        compoundedByMachine: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "compounded_by_machine",
        },
        medicineNames: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "medicine_names",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_therapy_sequence",
};
const patientTherapySequenceConsumablesTable = {
    name: "patientTherapySequenceConsumables",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        consumableId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "consumable_id",
        },
        quantity: {
            type: "number",
            optional: false,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_therapy_sequence_consumables",
};
const patientTherapySequenceMedicineTable = {
    name: "patientTherapySequenceMedicine",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        patientId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "patient_id",
        },
        therapyDate: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "therapy_date",
        },
        activeSubstanceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "active_substance_id",
        },
        prescribedNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "prescribed_name_id",
        },
        doctorPrescribedNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "doctor_prescribed_name_id",
        },
        doctorPrescribedActiveSubstanceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "doctor_prescribed_active_substance_id",
        },
        doctorPrescribedTotalAmount: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "doctor_prescribed_total_amount",
        },
        doctorPrescribedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "doctor_prescribed_at",
        },
        autIdem: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "aut_idem",
        },
        formType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "form_type",
        },
        calculationMethod: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "calculation_method",
        },
        regularDose: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "regular_dose",
        },
        recommendedDose: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "recommended_dose",
        },
        precisionDecimals: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "precision_decimals",
        },
        doseProportion: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "dose_proportion",
        },
        totalAmount: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "total_amount",
        },
        preparationType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "preparation_type",
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        ageRanges: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "age_ranges",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_therapy_sequence_medicine",
};
const patientTherapySequenceObservationsTable = {
    name: "patientTherapySequenceObservations",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        note: {
            type: "string",
            optional: false,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient_therapy_sequence_observations",
};
const patientsTable = {
    name: "patients",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        nationalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_id",
        },
        familyName: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "family_name",
        },
        givenName: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "given_name",
        },
        sortableGivenName: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "sortable_given_name",
        },
        sortableFamilyName: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "sortable_family_name",
        },
        fullName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "full_name",
        },
        title: {
            type: "string",
            optional: true,
            customType: null,
        },
        birthDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "birth_date",
        },
        sex: {
            type: "string",
            optional: true,
            customType: null,
        },
        gender: {
            type: "string",
            optional: true,
            customType: null,
        },
        maritalStatus: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "marital_status",
        },
        nationality: {
            type: "string",
            optional: true,
            customType: null,
        },
        deceasedDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deceased_date",
        },
        isTestData: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_test_data",
        },
        familyDoctorId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "family_doctor_id",
        },
        responsibleDoctorId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "responsible_doctor_id",
        },
        hospitalPatientId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "hospital_patient_id",
        },
        searchText: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "search_text",
        },
        barcodePrintFlag: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "barcode_print_flag",
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        source: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "patient",
};
const pharmaciesTable = {
    name: "pharmacies",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: false,
            customType: null,
        },
        locationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "location_id",
        },
        email: {
            type: "string",
            optional: true,
            customType: null,
        },
        phone: {
            type: "string",
            optional: true,
            customType: null,
        },
        isSameAddress: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_same_address",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        ikNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "ik_number",
        },
        producerNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "producer_number",
        },
        labelName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "label_name",
        },
        addressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_id",
        },
        deliveryAddressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "delivery_address_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "pharmacy",
};
const prescribedNamesTable = {
    name: "prescribedNames",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "prescribed_names",
};
const productionDetailsTable = {
    name: "productionDetails",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        medicineId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "medicine_id",
        },
        batchId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "batch_id",
        },
        scaleMemoryNumber: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "scale_memory_number",
        },
        step: {
            type: "string",
            optional: false,
            customType: null,
        },
        substanceIndex: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "substance_index",
        },
        allocatedDose: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "allocated_dose",
        },
        expectedWeightGrams: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expected_weight_grams",
        },
        actualWeightGrams: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "actual_weight_grams",
        },
        recordedAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "recorded_at",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "production_details",
};
const productionLocationsTable = {
    name: "productionLocations",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        pharmacyId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "pharmacy_id",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "production_location",
};
const protocolTherapySequenceTable = {
    name: "protocolTherapySequence",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        protocolId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "protocol_id",
        },
        isNote: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_note",
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        day: {
            type: "number",
            optional: false,
            customType: null,
        },
        time: {
            type: "string",
            optional: false,
            customType: null,
        },
        carrierSolutionId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "carrier_solution_id",
        },
        applicationFormId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "application_form_id",
        },
        duration: {
            type: "number",
            optional: true,
            customType: null,
        },
        volume: {
            type: "number",
            optional: true,
            customType: null,
        },
        volumeMode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "volume_mode",
        },
        therapyNote: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "therapy_note",
        },
        pharmacyNote: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "pharmacy_note",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "protocol_therapy_sequence",
};
const protocolTherapySequenceMedicineTable = {
    name: "protocolTherapySequenceMedicine",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        activeSubstanceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "active_substance_id",
        },
        prescribedNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "prescribed_name_id",
        },
        autIdem: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "aut_idem",
        },
        formType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "form_type",
        },
        calculationMethod: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "calculation_method",
        },
        regularDose: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "regular_dose",
        },
        precisionDecimals: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "precision_decimals",
        },
        preparationType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "preparation_type",
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        ageRanges: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "age_ranges",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "protocol_therapy_sequence_medicine",
};
const protocolsTable = {
    name: "protocols",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        diagnosisId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "diagnosis_id",
        },
        cancerTypeId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "cancer_type_id",
        },
        stage: {
            type: "string",
            optional: true,
            customType: null,
        },
        isTrial: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_trial",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        totalCycles: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "total_cycles",
        },
        daysRepetition: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "days_repetition",
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const reportViewsTable = {
    name: "reportViews",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        tab: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        filters: {
            type: "json",
            optional: false,
            customType: null,
        },
        fieldIds: {
            type: "json",
            optional: false,
            customType: null,
            serverName: "field_ids",
        },
        position: {
            type: "number",
            optional: false,
            customType: null,
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "report_views",
};
const restVialsTable = {
    name: "restVials",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        internalId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "internal_id",
        },
        restVialNumber: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "rest_vial_number",
        },
        sequenceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "sequence_id",
        },
        tradeNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "trade_name_id",
        },
        amount: {
            type: "number",
            optional: true,
            customType: null,
        },
        stockLocationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_location_id",
        },
        expiryDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expiry_date",
        },
        batchId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "batch_id",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "rest_vials",
};
const returnsTable = {
    name: "returns",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        medicationName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "medication_name",
        },
        medicationForm: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "medication_form",
        },
        carrierId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "carrier_id",
        },
        sequenceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "sequence_id",
        },
        stockLocationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_location_id",
        },
        inUse: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "in_use",
        },
        expiryDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expiry_date",
        },
        reason: {
            type: "string",
            optional: true,
            customType: null,
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
};
const scaleAlibisTable = {
    name: "scaleAlibis",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        memoryNumber: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "memory_number",
        },
        receivedWeight: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "received_weight",
        },
        totalWeight: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "total_weight",
        },
        expectedWeight: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "expected_weight",
        },
        unit: {
            type: "string",
            optional: true,
            customType: null,
        },
        label: {
            type: "string",
            optional: false,
            customType: null,
        },
        therapySequenceId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "therapy_sequence_id",
        },
        scaleSerialNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "scale_serial_number",
        },
        replaced: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        raw: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "scale_alibis",
};
const sectionsTable = {
    name: "sections",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: false,
            customType: null,
        },
        locationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "location_id",
        },
        type: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        costCenterNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "cost_center_number",
        },
        orderNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "order_number",
        },
        herstellerNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "hersteller_number",
        },
        movementType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "movement_type",
        },
        deliveryAddress: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "delivery_address",
        },
        ikNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ik_number",
        },
        addressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "section",
};
const sessionTable = {
    name: "session",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        locationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "active_location_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
    },
    primaryKey: ["id"],
};
const settingsTable = {
    name: "settings",
    columns: {
        id: {
            type: "number",
            optional: false,
            customType: null,
        },
        bsaFormula: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "bsa_formula",
        },
        ibwFormula: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ibw_formula",
        },
        activeProtocolWarning: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "active_protocol_warning",
        },
        doctorRelease: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "doctor_release",
        },
        deliveryAutoRelease: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "delivery_auto_release",
        },
        autIdemLogic: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "aut_idem_logic",
        },
        validationBypass: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "validation_bypass",
        },
        prescribeByTradeName: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "prescribe_by_trade_name",
        },
        allowManualPatients: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "allow_manual_patients",
        },
        allowManualStock: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "allow_manual_stock",
        },
        markAdministeredOnDispatch: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "mark_administered_on_dispatch",
        },
        administrationMode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "administration_mode",
        },
        weightTolerance: {
            type: "number",
            optional: true,
            customType: null,
        },
        weightAutoConfirm: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "weight_auto_confirm",
        },
        weightAutoConfirmDelayMs: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "weight_auto_confirm_delay_ms",
        },
        language: {
            type: "string",
            optional: true,
            customType: null,
        },
        logoUrl: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "logo_url",
        },
        loginText: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "login_text",
        },
        patientNameOrder: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "patient_name_order",
        },
        patientIdentifier: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "patient_identifier",
        },
        allowVialReuse: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "allow_vial_reuse",
        },
        useVialSource: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "use_vial_source",
        },
        minimumSaveableVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "minimum_saveable_volume",
        },
        licence: {
            type: "string",
            optional: true,
            customType: null,
        },
        licenceTampered: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "licence_tampered",
        },
        dayZeroProtocol: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "day_zero_protocol",
        },
        showHospitalPatientId: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "show_hospital_patient_id",
        },
        useScales: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "use_scales",
        },
        recordScaleMemoryNumbers: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "record_scale_memory_numbers",
        },
        skipSolventStockCheck: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "skip_solvent_stock_check",
        },
        sessionDurationMinutes: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "session_duration_minutes",
        },
        prescribingDoctor: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "prescribing_doctor",
        },
        hospitalNumber: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "hospital_number",
        },
        customerName: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "customer_name",
        },
        wardNextToCustomerName: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "ward_next_to_customer_name",
        },
        manufacturer: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        tradeNameBeforeSubstance: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "trade_name_before_substance",
        },
        concentration: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        actualQuantity: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "actual_quantity",
        },
        preparedBy: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "prepared_by",
        },
        pharmacyNameAndAddress: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "pharmacy_name_and_address",
        },
        additionalLabelBarcode: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "additional_label_barcode",
        },
        labelVolume: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "label_volume",
        },
        bandTextCytotoxic: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "band_text_cytotoxic",
        },
        bandTextNonCytotoxic: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "band_text_non_cytotoxic",
        },
        labelCopies: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "label_copies",
        },
        labelSize: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "label_size",
        },
        printReportAutomatically: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "print_report_automatically",
        },
        includeLabelCopy: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "include_label_copy",
        },
        includeEndControlSignatures: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "include_end_control_signatures",
        },
        showScaleMemoryNumbers: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "show_scale_memory_numbers",
        },
        showProductCodeColumn: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "show_product_code_column",
        },
        concentrationBasis: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "concentration_basis",
        },
        deliveryNoteCopies: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "delivery_note_copies",
        },
        releaseApprovalRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "release_approval_required",
        },
        signatureLinesOnPrintouts: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "signature_lines_on_printouts",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const solutionDetailTypesTable = {
    name: "solutionDetailTypes",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        solutionDetailId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "solution_detail_id",
        },
        solutionTypeId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "solution_type_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "solution_detail_types",
};
const solutionDetailsTable = {
    name: "solutionDetails",
    columns: {
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        concentrationValue: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "concentration_value",
        },
        concentrationUnitId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "concentration_unit",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["drugCatalogItemId"],
    serverName: "solution_details",
};
const solutionTypesTable = {
    name: "solutionTypes",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "solution_types",
};
const stabilityRuleContainerMaterialsTable = {
    name: "stabilityRuleContainerMaterials",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        stabilityRuleId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "stability_rule_id",
        },
        containerMaterialId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "container_material_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "stability_rule_container_materials",
};
const stabilityRulesTable = {
    name: "stabilityRules",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        carrierDrugId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "carrier_solution_id",
        },
        additionalActiveSubstanceDrugId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "additional_active_substance_drug_id",
        },
        stabilityStage: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "stability_stage",
        },
        isDefaultStage: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_default_stage",
        },
        startEventNotes: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "start_event_notes",
        },
        storageLabelId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "storage_label_id",
        },
        tempMinC: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "temp_min_c",
        },
        tempMaxC: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "temp_max_c",
        },
        lightProtectionRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "light_protection_required",
        },
        moistureProtectionRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "moisture_protection_required",
        },
        doNotRefrigerate: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "do_not_refrigerate",
        },
        doNotFreeze: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "do_not_freeze",
        },
        controlledTemperature: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "controlled_temperature",
        },
        keepInOriginalPackaging: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "keep_in_original_packaging",
        },
        containerTypeId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "container_type_id",
        },
        singleDoseOnly: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "single_dose_only",
        },
        preservativePresent: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "preservative_present",
        },
        requiresAsepticHandling: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "requires_aseptic_handling",
        },
        durationValue: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "duration_value",
        },
        durationUnit: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "duration_unit",
        },
        expiryRuleType: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "expiry_rule_type",
        },
        microbiologicalLimitation: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "microbiological_limitation",
        },
        discardRemainderRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "discard_remainder_required",
        },
        compatibilityNotes: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "compatibility_notes",
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        labelCopies: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "label_copies",
        },
        source: {
            type: "string",
            optional: false,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "stability_rules",
};
const stockLocationsTable = {
    name: "stockLocations",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "stock_locations",
};
const stockMovementsTable = {
    name: "stockMovements",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        type: {
            type: "string",
            optional: false,
            customType: null,
        },
        performedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "performed_at",
        },
        batchId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "batch_id",
        },
        quantity: {
            type: "number",
            optional: true,
            customType: null,
        },
        quantityUnitId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "quantity_unit_id",
        },
        packages: {
            type: "number",
            optional: true,
            customType: null,
        },
        source: {
            type: "string",
            optional: true,
            customType: null,
        },
        reason: {
            type: "string",
            optional: true,
            customType: null,
        },
        note: {
            type: "string",
            optional: true,
            customType: null,
        },
        stockLocationId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_location_id",
        },
        sequenceId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "sequence_id",
        },
        orderId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "order_id",
        },
        restVialId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "rest_vial_id",
        },
        returnId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "return_id",
        },
        discardId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "discard_id",
        },
        deliveryNoteNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "delivery_note_number",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "stock_movements",
};
const stocksTable = {
    name: "stocks",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        tradeNameId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "trade_name_id",
        },
        consumableId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "consumable_id",
        },
        totalQuantity: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "total_quantity",
        },
        earliestExpiryDate: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expiry_date",
        },
        hasUnacknowledgedExpiredBatches: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "has_unacknowledged_expired_batches",
        },
        stockStatus: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "stock_status",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const storageLabelsTable = {
    name: "storageLabels",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "storage_labels",
};
const supportiveMedicationDetailsTable = {
    name: "supportiveMedicationDetails",
    columns: {
        drugCatalogItemId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "drug_catalog_item_id",
        },
        doseCalcMode: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "dose_calc_mode",
        },
        doseUnitId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "dose_unit_id",
        },
        dosePrecision: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "dose_precision",
        },
        doseLimits: {
            type: "json",
            optional: true,
            customType: null,
            serverName: "dose_limits",
        },
        roundingMode: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "rounding_mode",
        },
        overdosePreventionLevel: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "overdose_prevention_level",
        },
        externalInformationLink: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "external_information_link",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["drugCatalogItemId"],
    serverName: "supportive_medication_details",
};
const tradeNameConsumablesTable = {
    name: "tradeNameConsumables",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        tradeNameId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "trade_name_id",
        },
        consumableId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "consumable_id",
        },
        units: {
            type: "number",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "trade_name_consumables",
};
const tradeNameReconstitutionSolventsTable = {
    name: "tradeNameReconstitutionSolvents",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        tradeNameId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "trade_name_id",
        },
        solutionDrugId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "solution_drug_id",
        },
        solventVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "solvent_volume",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "trade_name_reconstitution_solvents",
};
const tradeNameStabilityRulesTable = {
    name: "tradeNameStabilityRules",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        tradeNameId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "trade_name_id",
        },
        stabilityRuleId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "stability_rule_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "trade_name_stability_rules",
};
const tradeNamesTable = {
    name: "tradeNames",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        atcCode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "atc_code",
        },
        labelName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "label_name",
        },
        prescribedNameId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "prescribed_name_id",
        },
        nationalId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_id",
        },
        barcodeGtin: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "barcode_gtin",
        },
        isTrial: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_trial",
        },
        externalInformationLink: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "external_information_link",
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        productionNotes: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "production_notes",
        },
        density: {
            type: "number",
            optional: true,
            customType: null,
        },
        medicationProfileId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "medication_profile_id",
        },
        manufacturerId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "manufacturer_id",
        },
        unitsPerPackage: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "units_per_package",
        },
        minimumStock: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "minimum_stock",
        },
        containerTypeId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "container_type_id",
        },
        containerMaterialId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "container_material_id",
        },
        volumeValue: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "volume_value",
        },
        overfilledBy: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "overfilled_by",
        },
        actualVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "actual_volume",
        },
        reconstitutionRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "reconstitution_required",
        },
        additionalApprovalRequired: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "additional_approval_required",
        },
        containsAlcohol: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "contains_alcohol",
        },
        reconstitutedSolutionConcentration: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "reconstituted_solution_concentration",
        },
        reconstitutedConcentrationUnitId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "reconstituted_concentration_unit_id",
        },
        reconstitutedSolutionVolumeExpansion: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "reconstituted_solution_volume_expansion",
        },
        containerContents: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "container_contents",
        },
        maxVolumeCapacity: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "max_volume",
        },
        concentrationValue: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "concentration_value",
        },
        concentrationUnitId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "concentration_unit_id",
        },
        strengthValue: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "strength_value",
        },
        strengthUnitId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "strength_unit_id",
        },
        additionalsUsed: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "additionals_used",
        },
        additionalsDetails: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "additionals_details",
        },
        additionalsWeight: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "additionals_weight",
        },
        minimumSaveableVolume: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "minimum_saveable_volume",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "trade_names",
};
const treatmentChairsTable = {
    name: "treatmentChairs",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: true,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "treatment_chairs",
};
const unitsTable = {
    name: "units",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        displayName: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "display_name",
        },
        ucumCode: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "ucum_code",
        },
        ucumNumericCode: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ucum_numeric_code",
        },
        description: {
            type: "string",
            optional: true,
            customType: null,
        },
        notes: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
};
const userTable = {
    name: "user",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        email: {
            type: "string",
            optional: false,
            customType: null,
        },
        emailVerified: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "email_verified",
        },
        image: {
            type: "string",
            optional: true,
            customType: null,
        },
        username: {
            type: "string",
            optional: true,
            customType: null,
        },
        displayUsername: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "display_username",
        },
        firstName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "first_name",
        },
        lastName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "last_name",
        },
        role: {
            type: "string",
            optional: true,
            customType: null,
        },
        title: {
            type: "string",
            optional: true,
            customType: null,
        },
        hospitalSystemId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "hospital_system_id",
        },
        nationalPhysicianNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "national_physician_number",
        },
        hospitalPhysicianNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "hospital_physician_number",
        },
        isActiveOnCypro: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_active_on_cypro",
        },
        addressId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "address_id",
        },
        banned: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        banReason: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ban_reason",
        },
        banExpires: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "ban_expires",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const userAccessLocationTable = {
    name: "userAccessLocation",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        locationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "location_id",
        },
        sectionId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "section_id",
        },
        wardId: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ward_id",
        },
        role: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
    },
    primaryKey: ["id"],
    serverName: "user_access_location",
};
const userGroupsTable = {
    name: "userGroups",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        groupId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "group_id",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "user_group",
};
const wardsTable = {
    name: "wards",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        cyproOldId: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "cypro_old_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        code: {
            type: "string",
            optional: false,
            customType: null,
        },
        locationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "location_id",
        },
        sectionId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "section_id",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        costCenterNumber: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "cost_center_number",
        },
        orderNumber: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "order_number",
        },
        movementType: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "movement_type",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
    serverName: "ward",
};
const userRelationships = {
    groups: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "userGroups",
            cardinality: "many",
        },
        {
            sourceField: ["groupId"],
            destField: ["id"],
            destSchema: "groups",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    updated: [
        {
            sourceField: ["updatedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    address: [
        {
            sourceField: ["addressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    userAccessLocations: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "userAccessLocation",
            cardinality: "many",
        },
    ],
    sessions: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "session",
            cardinality: "many",
        },
    ],
    accounts: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "account",
            cardinality: "many",
        },
    ],
};
const accountRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const activeSubstanceDetailsRelationships = {
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    doseUnit: [
        {
            sourceField: ["doseUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    hazardClasses: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["activeSubstanceDetailId"],
            destSchema: "activeSubstanceHazardClasses",
            cardinality: "many",
        },
    ],
};
const activeSubstanceHazardClassesRelationships = {
    activeSubstanceDetails: [
        {
            sourceField: ["activeSubstanceDetailId"],
            destField: ["drugCatalogItemId"],
            destSchema: "activeSubstanceDetails",
            cardinality: "one",
        },
    ],
    hazardClass: [
        {
            sourceField: ["hazardClassId"],
            destField: ["id"],
            destSchema: "hazardClasses",
            cardinality: "one",
        },
    ],
};
const adminRoutesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const applicationFormsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const batchesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    consumable: [
        {
            sourceField: ["consumableId"],
            destField: ["id"],
            destSchema: "consumables",
            cardinality: "one",
        },
    ],
    supplierCompany: [
        {
            sourceField: ["supplierCompanyId"],
            destField: ["id"],
            destSchema: "companies",
            cardinality: "one",
        },
    ],
    stockLocation: [
        {
            sourceField: ["stockLocationId"],
            destField: ["id"],
            destSchema: "stockLocations",
            cardinality: "one",
        },
    ],
};
const cancerTypesRelationships = {
    protocols: [
        {
            sourceField: ["id"],
            destField: ["cancerTypeId"],
            destSchema: "protocols",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const cleanroomStatesRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
};
const companiesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const compoundOrdersRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    order: [
        {
            sourceField: ["orderId"],
            destField: ["id"],
            destSchema: "orders",
            cardinality: "one",
        },
    ],
    result: [
        {
            sourceField: ["id"],
            destField: ["compoundOrderId"],
            destSchema: "compoundResults",
            cardinality: "one",
        },
    ],
};
const compoundResultComponentsRelationships = {
    compoundResult: [
        {
            sourceField: ["compoundResultId"],
            destField: ["id"],
            destSchema: "compoundResults",
            cardinality: "one",
        },
    ],
};
const compoundResultsRelationships = {
    compoundOrder: [
        {
            sourceField: ["compoundOrderId"],
            destField: ["id"],
            destSchema: "compoundOrders",
            cardinality: "one",
        },
    ],
    components: [
        {
            sourceField: ["id"],
            destField: ["compoundResultId"],
            destSchema: "compoundResultComponents",
            cardinality: "many",
        },
    ],
};
const consumablesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    batches: [
        {
            sourceField: ["id"],
            destField: ["consumableId"],
            destSchema: "batches",
            cardinality: "many",
        },
    ],
};
const containerMaterialsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const containerTypesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const customersRelationships = {
    pharmacy: [
        {
            sourceField: ["pharmacyId"],
            destField: ["id"],
            destSchema: "pharmacies",
            cardinality: "one",
        },
    ],
    address: [
        {
            sourceField: ["addressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    deliveryAddress: [
        {
            sourceField: ["deliveryAddressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const diagnosesRelationships = {
    protocols: [
        {
            sourceField: ["id"],
            destField: ["diagnosisId"],
            destSchema: "protocols",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const discardsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    batch: [
        {
            sourceField: ["batchId"],
            destField: ["id"],
            destSchema: "batches",
            cardinality: "one",
        },
    ],
    restVial: [
        {
            sourceField: ["restVialId"],
            destField: ["id"],
            destSchema: "restVials",
            cardinality: "one",
        },
    ],
    return: [
        {
            sourceField: ["returnId"],
            destField: ["id"],
            destSchema: "returns",
            cardinality: "one",
        },
    ],
    lastLocation: [
        {
            sourceField: ["lastLocationId"],
            destField: ["id"],
            destSchema: "stockLocations",
            cardinality: "one",
        },
    ],
};
const drugCatalogItemsCategoriesRelationships = {
    drugCategory: [
        {
            sourceField: ["drugCategoryId"],
            destField: ["id"],
            destSchema: "drugsCategories",
            cardinality: "one",
        },
    ],
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
};
const drugCatalogItemsRelationships = {
    activeSubstanceDetails: [
        {
            sourceField: ["id"],
            destField: ["drugCatalogItemId"],
            destSchema: "activeSubstanceDetails",
            cardinality: "one",
        },
    ],
    supportiveMedicationDetails: [
        {
            sourceField: ["id"],
            destField: ["drugCatalogItemId"],
            destSchema: "supportiveMedicationDetails",
            cardinality: "one",
        },
    ],
    solutionDetails: [
        {
            sourceField: ["id"],
            destField: ["drugCatalogItemId"],
            destSchema: "solutionDetails",
            cardinality: "one",
        },
    ],
    medicationProfiles: [
        {
            sourceField: ["id"],
            destField: ["drugCatalogItemId"],
            destSchema: "medicationProfiles",
            cardinality: "many",
        },
    ],
    asAllowedCarrierForProfiles: [
        {
            sourceField: ["id"],
            destField: ["solutionDrugId"],
            destSchema: "medicationProfileAllowedCarrierSolutions",
            cardinality: "many",
        },
    ],
    asAllowedDiluentForProfiles: [
        {
            sourceField: ["id"],
            destField: ["solutionDrugId"],
            destSchema: "medicationProfileAllowedReconstitutionDiluents",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    categories: [
        {
            sourceField: ["id"],
            destField: ["drugCatalogItemId"],
            destSchema: "drugCatalogItemsCategories",
            cardinality: "many",
        },
    ],
};
const drugsCategoriesRelationships = {
    parent: [
        {
            sourceField: ["parentId"],
            destField: ["id"],
            destSchema: "drugsCategories",
            cardinality: "one",
        },
    ],
    children: [
        {
            sourceField: ["id"],
            destField: ["parentId"],
            destSchema: "drugsCategories",
            cardinality: "many",
        },
    ],
    drugCatalogItemsCategories: [
        {
            sourceField: ["id"],
            destField: ["drugCategoryId"],
            destSchema: "drugCatalogItemsCategories",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const eventLogsRelationships = {
    actor: [
        {
            sourceField: ["performedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    patientProtocol: [
        {
            sourceField: ["resourceId"],
            destField: ["id"],
            destSchema: "patientProtocols",
            cardinality: "one",
        },
    ],
    patientTherapySequence: [
        {
            sourceField: ["resourceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    patientTherapySequenceMedicine: [
        {
            sourceField: ["resourceId"],
            destField: ["id"],
            destSchema: "patientTherapySequenceMedicine",
            cardinality: "one",
        },
    ],
    patientGfr: [
        {
            sourceField: ["resourceId"],
            destField: ["id"],
            destSchema: "patientGfrs",
            cardinality: "one",
        },
    ],
};
const generalPhysiciansRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const groupsRelationships = {
    members: [
        {
            sourceField: ["id"],
            destField: ["groupId"],
            destSchema: "userGroups",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const hazardClassesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const insuranceCompaniesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const locationsRelationships = {
    sections: [
        {
            sourceField: ["id"],
            destField: ["locationId"],
            destSchema: "sections",
            cardinality: "many",
        },
    ],
    wards: [
        {
            sourceField: ["id"],
            destField: ["locationId"],
            destSchema: "wards",
            cardinality: "many",
        },
    ],
    userAccessLocations: [
        {
            sourceField: ["id"],
            destField: ["locationId"],
            destSchema: "userAccessLocation",
            cardinality: "many",
        },
    ],
};
const medicationProfileAllowedCarrierSolutionsRelationships = {
    medicationProfile: [
        {
            sourceField: ["medicationProfileId"],
            destField: ["id"],
            destSchema: "medicationProfiles",
            cardinality: "one",
        },
    ],
    solutionDrug: [
        {
            sourceField: ["solutionDrugId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
};
const medicationProfileAllowedReconstitutionDiluentsRelationships = {
    medicationProfile: [
        {
            sourceField: ["medicationProfileId"],
            destField: ["id"],
            destSchema: "medicationProfiles",
            cardinality: "one",
        },
    ],
    solutionDrug: [
        {
            sourceField: ["solutionDrugId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
};
const medicationProfilesRelationships = {
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    medicineForm: [
        {
            sourceField: ["medicineFormId"],
            destField: ["id"],
            destSchema: "medicineForms",
            cardinality: "one",
        },
    ],
    allowedReconstitutionDiluents: [
        {
            sourceField: ["id"],
            destField: ["medicationProfileId"],
            destSchema: "medicationProfileAllowedReconstitutionDiluents",
            cardinality: "many",
        },
    ],
    allowedCarrierSolutions: [
        {
            sourceField: ["id"],
            destField: ["medicationProfileId"],
            destSchema: "medicationProfileAllowedCarrierSolutions",
            cardinality: "many",
        },
    ],
    stabilityRules: [
        {
            sourceField: ["id"],
            destField: ["medicationProfileId"],
            destSchema: "medicationStabilityRules",
            cardinality: "many",
        },
    ],
    tradeNames: [
        {
            sourceField: ["id"],
            destField: ["medicationProfileId"],
            destSchema: "tradeNames",
            cardinality: "many",
        },
    ],
};
const medicationStabilityRulesRelationships = {
    medicationProfile: [
        {
            sourceField: ["medicationProfileId"],
            destField: ["id"],
            destSchema: "medicationProfiles",
            cardinality: "one",
        },
    ],
    stabilityRule: [
        {
            sourceField: ["stabilityRuleId"],
            destField: ["id"],
            destSchema: "stabilityRules",
            cardinality: "one",
        },
    ],
};
const medicineFormsRelationships = {
    medicationProfiles: [
        {
            sourceField: ["id"],
            destField: ["medicineFormId"],
            destSchema: "medicationProfiles",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const orderBatchesRelationships = {
    order: [
        {
            sourceField: ["orderId"],
            destField: ["id"],
            destSchema: "orders",
            cardinality: "one",
        },
    ],
    batch: [
        {
            sourceField: ["batchId"],
            destField: ["id"],
            destSchema: "batches",
            cardinality: "one",
        },
    ],
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
};
const ordersRelationships = {
    productionLocation: [
        {
            sourceField: ["productionLocationId"],
            destField: ["id"],
            destSchema: "productionLocations",
            cardinality: "one",
        },
    ],
    sequences: [
        {
            sourceField: ["id"],
            destField: ["orderId"],
            destSchema: "patientTherapySequence",
            cardinality: "many",
        },
    ],
    batches: [
        {
            sourceField: ["id"],
            destField: ["orderId"],
            destSchema: "orderBatches",
            cardinality: "many",
        },
    ],
};
const patientCharacteristicsRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    diagnosis: [
        {
            sourceField: ["diagnosisId"],
            destField: ["id"],
            destSchema: "diagnoses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientContactsRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    address: [
        {
            sourceField: ["addressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientEncountersRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    section: [
        {
            sourceField: ["sectionId"],
            destField: ["id"],
            destSchema: "sections",
            cardinality: "one",
        },
    ],
    ward: [
        {
            sourceField: ["wardId"],
            destField: ["id"],
            destSchema: "wards",
            cardinality: "one",
        },
    ],
    customer: [
        {
            sourceField: ["customerId"],
            destField: ["id"],
            destSchema: "customers",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientGfrsRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientIdentifiersRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientInsurancesRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    insuranceCompany: [
        {
            sourceField: ["companyId"],
            destField: ["id"],
            destSchema: "insuranceCompanies",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientProtocolsRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    protocol: [
        {
            sourceField: ["protocolId"],
            destField: ["id"],
            destSchema: "protocols",
            cardinality: "one",
        },
    ],
    therapySequence: [
        {
            sourceField: ["id"],
            destField: ["patientProtocolId"],
            destSchema: "patientTherapySequence",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    familyDoctor: [
        {
            sourceField: ["familyDoctorId"],
            destField: ["id"],
            destSchema: "generalPhysicians",
            cardinality: "one",
        },
    ],
    responsibleDoctor: [
        {
            sourceField: ["responsibleDoctorId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    identifiers: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientIdentifiers",
            cardinality: "many",
        },
    ],
    contacts: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientContacts",
            cardinality: "many",
        },
    ],
    characteristics: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientCharacteristics",
            cardinality: "many",
        },
    ],
    encounters: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientEncounters",
            cardinality: "many",
        },
    ],
    insurance: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientInsurances",
            cardinality: "one",
        },
    ],
    gfrs: [
        {
            sourceField: ["id"],
            destField: ["patientId"],
            destSchema: "patientGfrs",
            cardinality: "many",
        },
    ],
};
const patientTherapySequenceConsumablesRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    consumable: [
        {
            sourceField: ["consumableId"],
            destField: ["id"],
            destSchema: "consumables",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientTherapySequenceMedicineRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    activeSubstance: [
        {
            sourceField: ["activeSubstanceId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    prescribedName: [
        {
            sourceField: ["prescribedNameId"],
            destField: ["id"],
            destSchema: "prescribedNames",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientTherapySequenceObservationsRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const patientTherapySequenceRelationships = {
    patient: [
        {
            sourceField: ["patientId"],
            destField: ["id"],
            destSchema: "patients",
            cardinality: "one",
        },
    ],
    patientProtocol: [
        {
            sourceField: ["patientProtocolId"],
            destField: ["id"],
            destSchema: "patientProtocols",
            cardinality: "one",
        },
    ],
    protocol: [
        {
            sourceField: ["protocolId"],
            destField: ["id"],
            destSchema: "protocols",
            cardinality: "one",
        },
    ],
    carrierSolution: [
        {
            sourceField: ["carrierSolutionId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    applicationForm: [
        {
            sourceField: ["applicationFormId"],
            destField: ["id"],
            destSchema: "applicationForms",
            cardinality: "one",
        },
    ],
    order: [
        {
            sourceField: ["orderId"],
            destField: ["id"],
            destSchema: "orders",
            cardinality: "one",
        },
    ],
    batches: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "orderBatches",
            cardinality: "many",
        },
    ],
    productionDetails: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "productionDetails",
            cardinality: "many",
        },
    ],
    cleanroomState: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "cleanroomStates",
            cardinality: "one",
        },
    ],
    chair: [
        {
            sourceField: ["chairId"],
            destField: ["id"],
            destSchema: "treatmentChairs",
            cardinality: "one",
        },
    ],
    medicine: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "patientTherapySequenceMedicine",
            cardinality: "many",
        },
    ],
    observations: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "patientTherapySequenceObservations",
            cardinality: "many",
        },
    ],
    consumables: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "patientTherapySequenceConsumables",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    responsibleDoctor: [
        {
            sourceField: ["responsibleDoctorId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    doctorValidated: [
        {
            sourceField: ["doctorValidatedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    pharmacistValidated: [
        {
            sourceField: ["pharmacistValidatedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    administeredByUser: [
        {
            sourceField: ["administeredBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const pharmaciesRelationships = {
    location: [
        {
            sourceField: ["locationId"],
            destField: ["id"],
            destSchema: "locations",
            cardinality: "one",
        },
    ],
    address: [
        {
            sourceField: ["addressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    deliveryAddress: [
        {
            sourceField: ["deliveryAddressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    productionLocations: [
        {
            sourceField: ["id"],
            destField: ["pharmacyId"],
            destSchema: "productionLocations",
            cardinality: "many",
        },
    ],
};
const prescribedNamesRelationships = {
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    tradeNames: [
        {
            sourceField: ["id"],
            destField: ["prescribedNameId"],
            destSchema: "tradeNames",
            cardinality: "many",
        },
    ],
};
const productionDetailsRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    medicine: [
        {
            sourceField: ["medicineId"],
            destField: ["id"],
            destSchema: "patientTherapySequenceMedicine",
            cardinality: "one",
        },
    ],
    batch: [
        {
            sourceField: ["batchId"],
            destField: ["id"],
            destSchema: "batches",
            cardinality: "one",
        },
    ],
};
const productionLocationsRelationships = {
    pharmacy: [
        {
            sourceField: ["pharmacyId"],
            destField: ["id"],
            destSchema: "pharmacies",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const protocolTherapySequenceMedicineRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "protocolTherapySequence",
            cardinality: "one",
        },
    ],
    activeSubstance: [
        {
            sourceField: ["activeSubstanceId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    prescribedName: [
        {
            sourceField: ["prescribedNameId"],
            destField: ["id"],
            destSchema: "prescribedNames",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const protocolTherapySequenceRelationships = {
    protocol: [
        {
            sourceField: ["protocolId"],
            destField: ["id"],
            destSchema: "protocols",
            cardinality: "one",
        },
    ],
    carrierSolution: [
        {
            sourceField: ["carrierSolutionId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    applicationForm: [
        {
            sourceField: ["applicationFormId"],
            destField: ["id"],
            destSchema: "applicationForms",
            cardinality: "one",
        },
    ],
    medicine: [
        {
            sourceField: ["id"],
            destField: ["therapySequenceId"],
            destSchema: "protocolTherapySequenceMedicine",
            cardinality: "many",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const protocolsRelationships = {
    diagnosis: [
        {
            sourceField: ["diagnosisId"],
            destField: ["id"],
            destSchema: "diagnoses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    cancerType: [
        {
            sourceField: ["cancerTypeId"],
            destField: ["id"],
            destSchema: "cancerTypes",
            cardinality: "one",
        },
    ],
    therapySequence: [
        {
            sourceField: ["id"],
            destField: ["protocolId"],
            destSchema: "protocolTherapySequence",
            cardinality: "many",
        },
    ],
};
const reportViewsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    updated: [
        {
            sourceField: ["updatedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const restVialsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    patientTherapySequence: [
        {
            sourceField: ["sequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    stockLocation: [
        {
            sourceField: ["stockLocationId"],
            destField: ["id"],
            destSchema: "stockLocations",
            cardinality: "one",
        },
    ],
    batch: [
        {
            sourceField: ["batchId"],
            destField: ["id"],
            destSchema: "batches",
            cardinality: "one",
        },
    ],
};
const returnsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    patientTherapySequence: [
        {
            sourceField: ["sequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    stockLocation: [
        {
            sourceField: ["stockLocationId"],
            destField: ["id"],
            destSchema: "stockLocations",
            cardinality: "one",
        },
    ],
};
const scaleAlibisRelationships = {
    therapySequence: [
        {
            sourceField: ["therapySequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
};
const sectionsRelationships = {
    location: [
        {
            sourceField: ["locationId"],
            destField: ["id"],
            destSchema: "locations",
            cardinality: "one",
        },
    ],
    address: [
        {
            sourceField: ["addressId"],
            destField: ["id"],
            destSchema: "addresses",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    wards: [
        {
            sourceField: ["id"],
            destField: ["sectionId"],
            destSchema: "wards",
            cardinality: "many",
        },
    ],
    userAccessLocation: [
        {
            sourceField: ["id"],
            destField: ["sectionId"],
            destSchema: "userAccessLocation",
            cardinality: "many",
        },
    ],
    patientsEncounters: [
        {
            sourceField: ["id"],
            destField: ["sectionId"],
            destSchema: "patientEncounters",
            cardinality: "many",
        },
    ],
};
const sessionRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    location: [
        {
            sourceField: ["locationId"],
            destField: ["id"],
            destSchema: "locations",
            cardinality: "one",
        },
    ],
};
const solutionDetailTypesRelationships = {
    solutionDetail: [
        {
            sourceField: ["solutionDetailId"],
            destField: ["drugCatalogItemId"],
            destSchema: "solutionDetails",
            cardinality: "one",
        },
    ],
    solutionType: [
        {
            sourceField: ["solutionTypeId"],
            destField: ["id"],
            destSchema: "solutionTypes",
            cardinality: "one",
        },
    ],
};
const solutionDetailsRelationships = {
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    concentrationUnit: [
        {
            sourceField: ["concentrationUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    types: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["solutionDetailId"],
            destSchema: "solutionDetailTypes",
            cardinality: "many",
        },
    ],
};
const solutionTypesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const stabilityRuleContainerMaterialsRelationships = {
    stabilityRule: [
        {
            sourceField: ["stabilityRuleId"],
            destField: ["id"],
            destSchema: "stabilityRules",
            cardinality: "one",
        },
    ],
    containerMaterial: [
        {
            sourceField: ["containerMaterialId"],
            destField: ["id"],
            destSchema: "containerMaterials",
            cardinality: "one",
        },
    ],
};
const stabilityRulesRelationships = {
    containerType: [
        {
            sourceField: ["containerTypeId"],
            destField: ["id"],
            destSchema: "containerTypes",
            cardinality: "one",
        },
    ],
    containerMaterials: [
        {
            sourceField: ["id"],
            destField: ["stabilityRuleId"],
            destSchema: "stabilityRuleContainerMaterials",
            cardinality: "many",
        },
    ],
    carrierDrug: [
        {
            sourceField: ["carrierDrugId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    additionalActiveSubstanceDrug: [
        {
            sourceField: ["additionalActiveSubstanceDrugId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    storageLabel: [
        {
            sourceField: ["storageLabelId"],
            destField: ["id"],
            destSchema: "storageLabels",
            cardinality: "one",
        },
    ],
};
const stockLocationsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const stockMovementsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    batch: [
        {
            sourceField: ["batchId"],
            destField: ["id"],
            destSchema: "batches",
            cardinality: "one",
        },
    ],
    quantityUnit: [
        {
            sourceField: ["quantityUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    stockLocation: [
        {
            sourceField: ["stockLocationId"],
            destField: ["id"],
            destSchema: "stockLocations",
            cardinality: "one",
        },
    ],
    patientTherapySequence: [
        {
            sourceField: ["sequenceId"],
            destField: ["id"],
            destSchema: "patientTherapySequence",
            cardinality: "one",
        },
    ],
    order: [
        {
            sourceField: ["orderId"],
            destField: ["id"],
            destSchema: "orders",
            cardinality: "one",
        },
    ],
    restVial: [
        {
            sourceField: ["restVialId"],
            destField: ["id"],
            destSchema: "restVials",
            cardinality: "one",
        },
    ],
    return: [
        {
            sourceField: ["returnId"],
            destField: ["id"],
            destSchema: "returns",
            cardinality: "one",
        },
    ],
    discard: [
        {
            sourceField: ["discardId"],
            destField: ["id"],
            destSchema: "discards",
            cardinality: "one",
        },
    ],
};
const stocksRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    consumable: [
        {
            sourceField: ["consumableId"],
            destField: ["id"],
            destSchema: "consumables",
            cardinality: "one",
        },
    ],
};
const storageLabelsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const supportiveMedicationDetailsRelationships = {
    drugCatalogItem: [
        {
            sourceField: ["drugCatalogItemId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
    doseUnit: [
        {
            sourceField: ["doseUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
};
const tradeNameConsumablesRelationships = {
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    consumable: [
        {
            sourceField: ["consumableId"],
            destField: ["id"],
            destSchema: "consumables",
            cardinality: "one",
        },
    ],
};
const tradeNameReconstitutionSolventsRelationships = {
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    solutionDrug: [
        {
            sourceField: ["solutionDrugId"],
            destField: ["id"],
            destSchema: "drugCatalogItems",
            cardinality: "one",
        },
    ],
};
const tradeNameStabilityRulesRelationships = {
    tradeName: [
        {
            sourceField: ["tradeNameId"],
            destField: ["id"],
            destSchema: "tradeNames",
            cardinality: "one",
        },
    ],
    stabilityRule: [
        {
            sourceField: ["stabilityRuleId"],
            destField: ["id"],
            destSchema: "stabilityRules",
            cardinality: "one",
        },
    ],
};
const tradeNamesRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    strengthUnit: [
        {
            sourceField: ["strengthUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    concentrationUnit: [
        {
            sourceField: ["concentrationUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    reconstitutedConcentrationUnit: [
        {
            sourceField: ["reconstitutedConcentrationUnitId"],
            destField: ["id"],
            destSchema: "units",
            cardinality: "one",
        },
    ],
    reconstitutionSolvents: [
        {
            sourceField: ["id"],
            destField: ["tradeNameId"],
            destSchema: "tradeNameReconstitutionSolvents",
            cardinality: "many",
        },
    ],
    consumables: [
        {
            sourceField: ["id"],
            destField: ["tradeNameId"],
            destSchema: "tradeNameConsumables",
            cardinality: "many",
        },
    ],
    containerMaterial: [
        {
            sourceField: ["containerMaterialId"],
            destField: ["id"],
            destSchema: "containerMaterials",
            cardinality: "one",
        },
    ],
    containerType: [
        {
            sourceField: ["containerTypeId"],
            destField: ["id"],
            destSchema: "containerTypes",
            cardinality: "one",
        },
    ],
    medicationProfile: [
        {
            sourceField: ["medicationProfileId"],
            destField: ["id"],
            destSchema: "medicationProfiles",
            cardinality: "one",
        },
    ],
    prescribedName: [
        {
            sourceField: ["prescribedNameId"],
            destField: ["id"],
            destSchema: "prescribedNames",
            cardinality: "one",
        },
    ],
    stabilityRules: [
        {
            sourceField: ["id"],
            destField: ["tradeNameId"],
            destSchema: "tradeNameStabilityRules",
            cardinality: "many",
        },
    ],
    batches: [
        {
            sourceField: ["id"],
            destField: ["tradeNameId"],
            destSchema: "batches",
            cardinality: "many",
        },
    ],
    manufacturer: [
        {
            sourceField: ["manufacturerId"],
            destField: ["id"],
            destSchema: "companies",
            cardinality: "one",
        },
    ],
};
const treatmentChairsRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const userAccessLocationRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    location: [
        {
            sourceField: ["locationId"],
            destField: ["id"],
            destSchema: "locations",
            cardinality: "one",
        },
    ],
    section: [
        {
            sourceField: ["sectionId"],
            destField: ["id"],
            destSchema: "sections",
            cardinality: "one",
        },
    ],
    ward: [
        {
            sourceField: ["wardId"],
            destField: ["id"],
            destSchema: "wards",
            cardinality: "one",
        },
    ],
};
const userGroupsRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    group: [
        {
            sourceField: ["groupId"],
            destField: ["id"],
            destSchema: "groups",
            cardinality: "one",
        },
    ],
};
const wardsRelationships = {
    location: [
        {
            sourceField: ["locationId"],
            destField: ["id"],
            destSchema: "locations",
            cardinality: "one",
        },
    ],
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    section: [
        {
            sourceField: ["sectionId"],
            destField: ["id"],
            destSchema: "sections",
            cardinality: "one",
        },
    ],
    userAccessLocation: [
        {
            sourceField: ["id"],
            destField: ["wardId"],
            destSchema: "userAccessLocation",
            cardinality: "many",
        },
    ],
    patientsEncounters: [
        {
            sourceField: ["id"],
            destField: ["wardId"],
            destSchema: "patientEncounters",
            cardinality: "many",
        },
    ],
};
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
    tables: {
        HL7EventLog: hl7EventLogTable,
        account: accountTable,
        activeSubstanceDetails: activeSubstanceDetailsTable,
        activeSubstanceHazardClasses: activeSubstanceHazardClassesTable,
        addresses: addressesTable,
        adminRoutes: adminRoutesTable,
        applicationForms: applicationFormsTable,
        batches: batchesTable,
        cancerTypes: cancerTypesTable,
        cleanroomStates: cleanroomStatesTable,
        companies: companiesTable,
        compoundMappings: compoundMappingsTable,
        compoundOrders: compoundOrdersTable,
        compoundResultComponents: compoundResultComponentsTable,
        compoundResults: compoundResultsTable,
        consumables: consumablesTable,
        containerMaterials: containerMaterialsTable,
        containerTypes: containerTypesTable,
        customers: customersTable,
        diagnoses: diagnosesTable,
        discards: discardsTable,
        drugCatalogItems: drugCatalogItemsTable,
        drugCatalogItemsCategories: drugCatalogItemsCategoriesTable,
        drugsCategories: drugsCategoriesTable,
        eventLogs: eventLogsTable,
        generalPhysicians: generalPhysiciansTable,
        groups: groupsTable,
        hazardClasses: hazardClassesTable,
        insuranceCompanies: insuranceCompaniesTable,
        locations: locationsTable,
        medicationProfileAllowedCarrierSolutions: medicationProfileAllowedCarrierSolutionsTable,
        medicationProfileAllowedReconstitutionDiluents: medicationProfileAllowedReconstitutionDiluentsTable,
        medicationProfiles: medicationProfilesTable,
        medicationStabilityRules: medicationStabilityRulesTable,
        medicineForms: medicineFormsTable,
        orderBatches: orderBatchesTable,
        orders: ordersTable,
        patientCharacteristics: patientCharacteristicsTable,
        patientContacts: patientContactsTable,
        patientEncounters: patientEncountersTable,
        patientGfrs: patientGfrsTable,
        patientIdentifiers: patientIdentifiersTable,
        patientInsurances: patientInsurancesTable,
        patientProtocols: patientProtocolsTable,
        patientTherapySequence: patientTherapySequenceTable,
        patientTherapySequenceConsumables: patientTherapySequenceConsumablesTable,
        patientTherapySequenceMedicine: patientTherapySequenceMedicineTable,
        patientTherapySequenceObservations: patientTherapySequenceObservationsTable,
        patients: patientsTable,
        pharmacies: pharmaciesTable,
        prescribedNames: prescribedNamesTable,
        productionDetails: productionDetailsTable,
        productionLocations: productionLocationsTable,
        protocolTherapySequence: protocolTherapySequenceTable,
        protocolTherapySequenceMedicine: protocolTherapySequenceMedicineTable,
        protocols: protocolsTable,
        reportViews: reportViewsTable,
        restVials: restVialsTable,
        returns: returnsTable,
        scaleAlibis: scaleAlibisTable,
        sections: sectionsTable,
        session: sessionTable,
        settings: settingsTable,
        solutionDetailTypes: solutionDetailTypesTable,
        solutionDetails: solutionDetailsTable,
        solutionTypes: solutionTypesTable,
        stabilityRuleContainerMaterials: stabilityRuleContainerMaterialsTable,
        stabilityRules: stabilityRulesTable,
        stockLocations: stockLocationsTable,
        stockMovements: stockMovementsTable,
        stocks: stocksTable,
        storageLabels: storageLabelsTable,
        supportiveMedicationDetails: supportiveMedicationDetailsTable,
        tradeNameConsumables: tradeNameConsumablesTable,
        tradeNameReconstitutionSolvents: tradeNameReconstitutionSolventsTable,
        tradeNameStabilityRules: tradeNameStabilityRulesTable,
        tradeNames: tradeNamesTable,
        treatmentChairs: treatmentChairsTable,
        units: unitsTable,
        user: userTable,
        userAccessLocation: userAccessLocationTable,
        userGroups: userGroupsTable,
        wards: wardsTable,
    },
    relationships: {
        user: userRelationships,
        account: accountRelationships,
        activeSubstanceDetails: activeSubstanceDetailsRelationships,
        activeSubstanceHazardClasses: activeSubstanceHazardClassesRelationships,
        adminRoutes: adminRoutesRelationships,
        applicationForms: applicationFormsRelationships,
        batches: batchesRelationships,
        cancerTypes: cancerTypesRelationships,
        cleanroomStates: cleanroomStatesRelationships,
        companies: companiesRelationships,
        compoundOrders: compoundOrdersRelationships,
        compoundResultComponents: compoundResultComponentsRelationships,
        compoundResults: compoundResultsRelationships,
        consumables: consumablesRelationships,
        containerMaterials: containerMaterialsRelationships,
        containerTypes: containerTypesRelationships,
        customers: customersRelationships,
        diagnoses: diagnosesRelationships,
        discards: discardsRelationships,
        drugCatalogItemsCategories: drugCatalogItemsCategoriesRelationships,
        drugCatalogItems: drugCatalogItemsRelationships,
        drugsCategories: drugsCategoriesRelationships,
        eventLogs: eventLogsRelationships,
        generalPhysicians: generalPhysiciansRelationships,
        groups: groupsRelationships,
        hazardClasses: hazardClassesRelationships,
        insuranceCompanies: insuranceCompaniesRelationships,
        locations: locationsRelationships,
        medicationProfileAllowedCarrierSolutions: medicationProfileAllowedCarrierSolutionsRelationships,
        medicationProfileAllowedReconstitutionDiluents: medicationProfileAllowedReconstitutionDiluentsRelationships,
        medicationProfiles: medicationProfilesRelationships,
        medicationStabilityRules: medicationStabilityRulesRelationships,
        medicineForms: medicineFormsRelationships,
        orderBatches: orderBatchesRelationships,
        orders: ordersRelationships,
        patientCharacteristics: patientCharacteristicsRelationships,
        patientContacts: patientContactsRelationships,
        patientEncounters: patientEncountersRelationships,
        patientGfrs: patientGfrsRelationships,
        patientIdentifiers: patientIdentifiersRelationships,
        patientInsurances: patientInsurancesRelationships,
        patientProtocols: patientProtocolsRelationships,
        patients: patientsRelationships,
        patientTherapySequenceConsumables: patientTherapySequenceConsumablesRelationships,
        patientTherapySequenceMedicine: patientTherapySequenceMedicineRelationships,
        patientTherapySequenceObservations: patientTherapySequenceObservationsRelationships,
        patientTherapySequence: patientTherapySequenceRelationships,
        pharmacies: pharmaciesRelationships,
        prescribedNames: prescribedNamesRelationships,
        productionDetails: productionDetailsRelationships,
        productionLocations: productionLocationsRelationships,
        protocolTherapySequenceMedicine: protocolTherapySequenceMedicineRelationships,
        protocolTherapySequence: protocolTherapySequenceRelationships,
        protocols: protocolsRelationships,
        reportViews: reportViewsRelationships,
        restVials: restVialsRelationships,
        returns: returnsRelationships,
        scaleAlibis: scaleAlibisRelationships,
        sections: sectionsRelationships,
        session: sessionRelationships,
        solutionDetailTypes: solutionDetailTypesRelationships,
        solutionDetails: solutionDetailsRelationships,
        solutionTypes: solutionTypesRelationships,
        stabilityRuleContainerMaterials: stabilityRuleContainerMaterialsRelationships,
        stabilityRules: stabilityRulesRelationships,
        stockLocations: stockLocationsRelationships,
        stockMovements: stockMovementsRelationships,
        stocks: stocksRelationships,
        storageLabels: storageLabelsRelationships,
        supportiveMedicationDetails: supportiveMedicationDetailsRelationships,
        tradeNameConsumables: tradeNameConsumablesRelationships,
        tradeNameReconstitutionSolvents: tradeNameReconstitutionSolventsRelationships,
        tradeNameStabilityRules: tradeNameStabilityRulesRelationships,
        tradeNames: tradeNamesRelationships,
        treatmentChairs: treatmentChairsRelationships,
        userAccessLocation: userAccessLocationRelationships,
        userGroups: userGroupsRelationships,
        wards: wardsRelationships,
    },
    enableLegacyQueries: false,
    enableLegacyMutators: false,
};
/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;
//# sourceMappingURL=zero-schema.gen.js.map